import CheckIcon from '@mui/icons-material/Check';
import { FormattedMessage } from 'react-intl';
import { useDeleteAllUsersFromGroupMutation } from '../../apiRtk/be4feApi';
import { useUrlParams } from '../../helpers/urlParams';
import { useGetGlobalInfo } from '../../hooks/useGetGlobalInfo';
import { IModalBase } from '../../modules/commonTypes';
import { TYPE_DESCRIPTOR } from '../../modules/notifications';
import { addSnackbarError, addSnackbarSuccess } from '../../modules/notifications/actions';
import { ActionModal } from '../_DesignSystemWrappers/Modal';
import messages from './messages';

interface AccessGroupEditMembershipModalProps extends IModalBase {
  groupId: string;
  onSuccess: () => void;
}

function AccessGroupEditMembershipModal({ groupId, onClose, onSuccess, open }: AccessGroupEditMembershipModalProps) {
  const { dispatch, formatMessage } = useGetGlobalInfo();
  const { companyId, siteId } = useUrlParams();
  const [deleteAllUsersFromGroup, { isLoading }] = useDeleteAllUsersFromGroupMutation();

  const onSubmit = () => {
    if (!companyId || !siteId || !groupId) {
      return;
    }

    deleteAllUsersFromGroup({
      companyId,
      groupId,
      siteId,
    })
      .unwrap()
      .then(() => {
        dispatch(addSnackbarSuccess(messages.accessManualGroupSwitched));
        onSuccess();
        onClose();
      })
      .catch(() => {
        dispatch(addSnackbarError(messages.accessManualGroupFailed, TYPE_DESCRIPTOR));
      });
  };

  return (
    <ActionModal
      icon={<CheckIcon />}
      open={open}
      isPrimaryButtonDisabled={!companyId || !siteId || !groupId}
      isPrimaryButtonLoading={isLoading}
      muiDialogProps={{ maxWidth: 'xs' }}
      primaryButtonAction={onSubmit}
      primaryButtonText={formatMessage(messages.accessGroupEditMembershipModalConfirm)}
      secondaryButtonText={formatMessage(messages.buttonsCancel)}
      onClose={onClose}
      title={formatMessage(messages.accessGroupEditMembershipModalTitle)}
      testId="access-group-edit-membership-modal"
    >
      <FormattedMessage
        {...messages.accessGroupEditMembershipModalText}
        values={{
          br: <br />,
        }}
      />
    </ActionModal>
  );
}

export default AccessGroupEditMembershipModal;
